import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=3979cd52&"
import script from "./MyProjects.vue?vue&type=script&lang=js&"
export * from "./MyProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3979cd52')) {
      api.createRecord('3979cd52', component.options)
    } else {
      api.reload('3979cd52', component.options)
    }
    module.hot.accept("./MyProjects.vue?vue&type=template&id=3979cd52&", function () {
      api.rerender('3979cd52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/MyProjects.vue"
export default component.exports